import $ from 'jquery';

export default class Placeholder {
  constructor(element) {
    this.$element = $(element);
    this.placeholderText = this.placeholderText;
  }

  get placeholderText() {
    return this.$element.find('label').text().trim();
  }

  set placeholderText(text) {
    if (text.length) {
      this.$element.find('input, textarea').attr('placeholder', text);
    }
  }
}
